import { Injectable, inject } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { BaseDataService } from "../../../data/services/base-data.service";
import {
    DELETE_FIBU_ACCOUNT,
    GET_FIBU_ACCOUNTS,
    SAVE_FIBU_ACCOUNT,
} from "../../../data/definitions/fibu.definition";
import {
    DeleteFibuAccountMutation,
    DeleteFibuAccountMutationVariables,
    DeletionResponse,
    FibuAccount,
    FibuAccountInput,
    GetFibuAccountsQuery,
    GetFibuAccountsQueryVariables,
    SaveFibuAccountMutation,
    SaveFibuAccountMutationVariables,
    SearchInput,
} from "../../../generated/generated-types";

/** ICRUD list service for {@link FibuAccount}, used by the shared list (Konten). */
@Injectable({ providedIn: "root" })
export class FibuAccountListService extends BaseListService<FibuAccount> {

    private readonly baseDataService = inject(BaseDataService);
    private readonly systemService = inject(SystemService);

    constructor() {
        super();
    }

    override getItems(searchInput?: SearchInput) {
        return this.baseDataService.query<GetFibuAccountsQuery, GetFibuAccountsQueryVariables>(
            GET_FIBU_ACCOUNTS,
            { input: searchInput as GetFibuAccountsQueryVariables["input"] },
        );
    }

    override async saveItem(item: FibuAccount | FibuAccountInput): Promise<FibuAccount> {
        const validated = await this.systemService.validateObject<FibuAccountInput>(item, "FibuAccountInput");
        const result = await lastValueFrom(
            this.baseDataService.mutate<SaveFibuAccountMutation, SaveFibuAccountMutationVariables>(
                SAVE_FIBU_ACCOUNT,
                { input: validated },
            ),
        );
        return result.saveFibuAccount as FibuAccount;
    }

    override async deleteItem(id: string): Promise<DeletionResponse> {
        const result = await lastValueFrom(
            this.baseDataService.mutate<DeleteFibuAccountMutation, DeleteFibuAccountMutationVariables>(
                DELETE_FIBU_ACCOUNT,
                { id },
            ),
        );
        return result.deleteFibuAccount as DeletionResponse;
    }
}
